import React from 'react';
import { CheckCircle } from 'lucide-react';

export default function FeedbackThankYou({ listeningTimeMinutes, onClose }) {
  const formatTime = (mins) => {
    if (!mins || mins < 1) return '< 1 min';
    if (mins < 60) return `${Math.round(mins)} min`;
    const h = Math.floor(mins / 60);
    const m = Math.round(mins % 60);
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  };

  return (
    <div className="session-feedback-overlay" onClick={onClose}>
      <div className="session-feedback-card sf-thankyou" onClick={(e) => e.stopPropagation()}>
        <div className="sf-thankyou-icon-wrapper">
          <div className="sf-thankyou-icon-glow" />
          <div className="sf-thankyou-icon">
            <CheckCircle size={64} />
          </div>
        </div>

        <h2 className="sf-thankyou-title">Thank you!</h2>
        <p className="sf-thankyou-text">
          Your feedback helps us create better vibes
        </p>

        <div className="sf-session-stats">
          <div className="sf-stat-box sf-stat-box--time">
            <span className="sf-stat-value">{formatTime(listeningTimeMinutes)}</span>
            <span className="sf-stat-label">Listening time</span>
          </div>
        </div>

        <button className="sf-close-hint-box" onClick={onClose}>
          <p className="sf-close-hint-text">You can close this window now</p>
        </button>
      </div>
    </div>
  );
}
